import { Select } from 'antd';
import React from 'react';
import { Location, SearchLocation } from '../api/models/locations';
import dayjs from 'dayjs';

export const getLocationSelectOptions = (
  locations: Location[] | SearchLocation[],
  getTitleFunc: (location: any) => string,
  optionStyle?: string,
  dataTestId?: string
) => {
  return locations.map((location, index) => (
    <Select.Option
      value={location.id}
      key={`dropoff_${location.id}`}
      className={optionStyle}
      data-testid={`${dataTestId || 'dropOffLocationItem'}_${index}`}
    >
      {getTitleFunc(location)}
    </Select.Option>
  ));
};

export const isNumber = (n?: number): boolean => {
  return Number(n) === n;
};

export const formatDateTime = (dateTime: number | Date | undefined) => dayjs(dateTime).format('DD/MM/YYYY hh:mm a');
